import _ from 'lodash'

export const SortArrayObject = (data = [], sortBy = []) => {
  return _.orderBy(data, sortBy)
}
